import clsx from "clsx"
import type { KeyboardEvent } from "react"

import type { SX } from "../../theme"
import { Text } from "../Text"
import styles from "./Tab.module.css"

export interface TabProps {
  title: string
  selected?: boolean
  onSelect?: () => void
  outline?: boolean
  background?: "transparent"
  sx?: SX
}

export function Tab(props: TabProps) {
  const { title, selected = false, onSelect, outline, background, sx } = props

  const tabClass = clsx(
    styles.root,
    selected ? styles.selected : styles.unselected,
    background && styles[`background-${background}`],
    outline && styles.outline
  )

  function onClick() {
    onSelect?.()
  }

  function onKeyDown(evt: KeyboardEvent) {
    if (evt.code === "Enter" || evt.code === "Space") onSelect?.()
  }

  return (
    <div
      role="button"
      tabIndex={0}
      className={tabClass}
      onClick={onClick}
      onKeyDown={onKeyDown}
      style={sx}
    >
      <Text variant="bold" color={selected ? "purple9" : "grey11"}>
        {title}
      </Text>
    </div>
  )
}
